import { FC, useContext } from 'react';

import dayjs from 'dayjs';

import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';

import { ITooltipProps } from '../interfaces';
import s from './Tooltip.module.scss';

export const Tooltip: FC<ITooltipProps> = ({ payload }) => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: { currency },
    },
  } = useContext(SettingsContext);
  const { startDate, finishDate, income, operator } = payload ?? {};

  const formattedStartDate = dayjs(startDate);
  const formattedEndDate = dayjs(finishDate);

  const startDay = formattedStartDate.format('DD.MM.YYYY');
  const startHour = formattedStartDate.format('HH:mm');

  const finishDay = formattedEndDate.format('DD.MM.YYYY');
  const finishHour = formattedEndDate.format('HH:mm');

  const workShiftDuration = formattedEndDate.diff(formattedStartDate, 'hours');

  return (
    <div className={s.root}>
      <div className={s.header}>
        <div className={s['income']}>
          {income?.toLocaleString()} {currency.sign}
        </div>
        <div className={s.duration}>
          {t(
            'time.contracted.hours',
            workShiftDuration ? workShiftDuration : '<1'
          )}
        </div>
      </div>
      <div className={s['operator']}>{operator}</div>
      <div className={s.time}>
        <div className={s['start']}>
          <div>{startDay} </div>
          <div>{startHour}</div>
        </div>
        →
        <div className={s['finish']}>
          <div>{finishDay}</div>
          <div>{finishHour}</div>
        </div>
      </div>
    </div>
  );
};
